/* eslint-disable no-console */
const $ = jQuery;
let bellowelm = null;

/**
 * Class accordion
 */
class Accordion {
	/**
	 * Constructor
	 *
	 * @param {jQuery} element jQuery bellow element.
	 */
	constructor(element) {
		this.accordion = element;
		this.triggers = this.accordion.find('.block-accordion-on-bellow__top');
		this.transition = 400;
		this.triggers.on('click', this.handleBellowClick.bind(this));

		// Get the next block bellow this one.
		if ($('.block-accordion-on-bellow').next().hasClass('hideme')) {
			$('.block-accordion-on-bellow')
				.next()
				.addClass('block-accordion-on-bellow__collapsable-content');
			bellowelm = $('.block-accordion-on-bellow').next();
		} else if ($('.block-accordion-on-bellow').next().hasClass('acf-block')) {
			$('.block-accordion-on-bellow')
				.next()
				.addClass('block-accordion-on-bellow__collapsable-content');
			bellowelm = $('.block-accordion-on-bellow').next();
		}
	}

	/**
	 * Handle bellow button click
	 *
	 * @param {Event} event
	 */
	handleBellowClick(event) {
		const isExpanded = event.currentTarget
			.closest('.block-accordion-on-bellow')
			.classList.contains('block-accordion-on-bellow--expanded');

		if (isExpanded) {
			$('.block-bellow__title-hide').hide();
			$('.block-bellow__title-show').show();
			this.collapseBellow(event.currentTarget);
		} else {
			$('.block-bellow__title-hide').show();
			$('.block-bellow__title-show').hide();
			this.expandBellow(event.currentTarget);
		}
	}

	/**
	 * Collapse Bellow
	 *
	 * @param {Object} target Event target
	 */
	collapseBellow(target) {
		const bellowTrigger = $(target);
		bellowTrigger
			.attr('aria-expanded', 'false')
			.parents('.block-accordion-on-bellow')
			.removeClass('block-accordion-on-bellow--expanded');
		bellowelm.removeClass('.block-accordion-on-bellow__collapsable--expanded');
		bellowelm.css('visibility', 'hidden');
		bellowelm.slideUp(this.transition);
	}

	/**
	 * Expand Bellow
	 *
	 * @param {Object} target Event target
	 */
	expandBellow(target) {
		const bellow = $(target);
		bellow
			.attr('aria-expanded', 'true')
			.parents('.block-accordion-on-bellow')
			.addClass('block-accordion-on-bellow--expanded');
		bellowelm.addClass('.block-accordion-on-bellow__collapsable--expanded');
		bellowelm.css('visibility', 'visible');
		bellowelm.slideDown(this.transition);
	}
}

new Accordion($('.block-accordion-on-bellow'));
